import { useMemo } from "react";

import type { BulkActionHandlersByType } from "@punto/frontend-shared/components/bulk-actions";

import { PRINT_BUNDLE_TYPE } from "@/modules/bulk-actions";
import { useCollegeFolderPrintHandlers } from "@/modules/college-folders/hooks/use-college-folder-print-handlers";
import { useDeliveryPrintHandlers } from "@/modules/deliveries/hooks/use-delivery-print-handlers";

/**
 * Every bulk-action type that does something on settle or download, keyed by
 * type. Composed here, in the app shell, rather than in `bulk-actions`: the
 * feature modules depend on `bulk-actions`, so `bulk-actions` must not depend
 * on them back. The rest of the types need no handlers.
 */
export const useBulkActionHandlers = (): BulkActionHandlersByType => {
  const collegeFolderPrint = useCollegeFolderPrintHandlers();
  const deliveryPrint = useDeliveryPrintHandlers();

  return useMemo(
    () => ({
      [PRINT_BUNDLE_TYPE.collegeFolder]: collegeFolderPrint,
      [PRINT_BUNDLE_TYPE.deliveryTracking]: deliveryPrint,
      [PRINT_BUNDLE_TYPE.deliveryTrackingProcedure]: deliveryPrint,
    }),
    [collegeFolderPrint, deliveryPrint],
  );
};
